export function isValidVrm(vrm, isCMSUser = false) {
    const regex = /(?<Current>^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(?<Prefix>^[A-Z][0-9]{1,3}\s?[A-Z]{3}$)|(?<Suffix>^[A-Z]{3}\s?[0-9]{1,3}[A-Z]$)|(?<DatelessLongNumberPrefix>^[0-9]{1,4}\s?[A-Z]{1,2}$)|(?<DatelessShortNumberPrefix>^[0-9]{1,3}\s?[A-Z]{1,3}$)|(?<DatelessLongNumberSuffix>^[A-Z]{1,2}\s?[0-9]{1,4}$)|(?<DatelessShortNumberSufix>^[A-Z]{1,3}\s?[0-9]{1,3}$)|(?<DatelessNorthernIreland>^[A-Z]{1,3}\s?[0-9]{1,4}$)|(?<DiplomaticPlate>^[0-9]{3}\s?[DX]{1}\s?[0-9]{3}$)/;
    const cleanedVrm = vrm.replace(/\s+/g, '').toUpperCase();
    let valid = regex.test(cleanedVrm);

    if(!valid && window.bugsnag && !isCMSUser) {
        window.bugsnag.notify(new Error("Vehicle API Lookup Failed"), (event) => {
            event.severity = "warning";
            event.addMetadata("details", { reason:  "Invalid VRM entered", vrm: vrm ?? "Unknown" });
        })
    }
    return valid;
}

export function missingFieldErrorText(vehicle, cmsUser = false) {
    const missingFields = [];
    if (!vehicle.make) missingFields.push('Make');
    if (!vehicle.model) missingFields.push('Model');
    if (!vehicle.year) missingFields.push('Year');

    const lastField = missingFields.pop();
    const fieldsString = missingFields.length
        ? missingFields.join(', ') + ' and ' + lastField
        : lastField;


    return cmsUser ? `${fieldsString} missing, enter manually.` :  `${fieldsString} not found, please enter manually below.`;
}

export function vehicleMotorhomeRegex(vehicle) {
    const regex = /MOTOR\s*HOME|CARAVAN/i

    return (
        vehicle?.door_plan_literal && regex.test(vehicle.door_plan_literal)
    )
}  

export function resetVehicleWithError(error, vehicle) {
 
    vehicle.make = {value: null}
    vehicle.model = {value: null}
    vehicle.year = {value: null}
    vehicle.result = null
    vehicle.class = {value: null}
    vehicle.parts_exclude = ""
    vehicle.hidden = false
    vehicle.manual = false
    vehicle.vrm.error = error
        
    return vehicle
}

export function suggestCorrectedVRM(vrm) {
    // Suggested VRM only for default VRM format (7 characters)
    const cleanedVrm = vrm.replace(/\s+/g, '').toUpperCase();
    let chars = cleanedVrm.split('');
    // check if charcters has changed, if so we can relookup vrm
    let hasChanged = false;

    // First two characters are letters → change 0 to O
    if (chars[0] === '0') {
        chars[0] = 'O';
        hasChanged = true;
    }
    if (chars[1] === '0') {
        chars[1] = 'O';
        hasChanged = true;
    }

    // Third and fourth are digits → change O to 0
    if (chars[2] === 'O') {
        chars[2] = '0';
        hasChanged = true;
    }
    if (chars[3] === 'O') {
        chars[3] = '0';
        hasChanged = true;
    }

    // Last three characters are letters → change 0 to O
    for (let i = chars.length - 3; i < chars.length; i++) {
        if (chars[i] === '0') {
            chars[i] = 'O';
            hasChanged = true;
        }
    }

    const suggestion = chars.join('');
    // validVrm is used as a sanity check for example LLLOPPP hasChanged but we need to see if it's valid before hitting lookup again
    const validVrm = isValidVrm(suggestion);
    return {
        suggestion: `${suggestion.slice(0, 4)} ${suggestion.slice(4)}`,
        hasChanged: hasChanged,
        validVrm: validVrm,
    };
}

export function compareUKRegistrationPeriods(currentDate, newDate) {
    // Direct comparison of UK registration periods from dates
    // Returns true if newDate is same period or newer than currentDate
    
    const current = parseUKDate(currentDate);
    const newVehicle = parseUKDate(newDate);
    
    if (!current || !newVehicle) {
        console.error('Invalid dates provided', { currentDate, newDate });
        return false;
    }

    const currentPeriod = getRegistrationPeriodFromDate(current);
    const newPeriod = getRegistrationPeriodFromDate(newVehicle);
    
    return newPeriod >= currentPeriod;
}

export function parseUKDate(dateString) {
    if (!dateString) return null;

    const ukDateRegex = /^(\d{2})[\/-](\d{2})[\/-](\d{4})$/;
    const match = dateString.match(ukDateRegex);

    if (match) {
        const day = match[1];
        const month = match[2];
        const year = match[3];
        return new Date(`${year}-${month}-${day}`);
    }
    
    // Fallback to standard Date parsing
    return new Date(dateString);
}

export function getRegistrationPeriodFromDate(date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // JavaScript months index starts at 0
    
    if (month >= 3 && month <= 8) {
        // March to August: first half of year
        return year + 0.0;
    } else {
        // September to February: second half of year
        const periodYear = month >= 9 ? year : year - 1;
        return periodYear + 0.5;
    }
}

export function normalizeVRM(vrm) {
    return vrm.trim().replace(/\s+/g, "").toUpperCase();
}

export function checkIfVehicleIsTooOld(year, isBusiness) {    
    if(!year) return false;    
    const currentYear = new Date().getFullYear();    
    const vehicleYear = parseInt(year);    
    
    if (isBusiness) {        
    return currentYear - vehicleYear > 20;    
    } else {       
     return currentYear - vehicleYear > 25;         
     }
}